import React, { ReactNode } from 'react'
type ContainerProps = {
    children: ReactNode;
    padding?: boolean,
    paddingValue?: string;
}
const Container = ({ children, padding, paddingValue }: ContainerProps) => {
    return (
        <div className={`bg-white border border-slate-200 dark:border-slate-500 dark:bg-[#0c4a6e90] rounded-md ${padding ? paddingValue||"p-4" : ""}`}>{children}</div>
    )
}
export default Container